(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frkm-scene"] && !Shopify.designMode) return;
  try {
    
  (function () {
    "use strict";

    var runtimeKey = "__frkmSceneRuntimeV1";

    if (window[runtimeKey]) {
      window[runtimeKey].scan(document);
      return;
    }

    var controllers = new Map();

    function rootsWithin(scope) {
      var roots = [];
      if (scope.matches && scope.matches("[data-frkm-scene]")) roots.push(scope);
      if (scope.querySelectorAll) roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll("[data-frkm-scene]")));
      return roots;
    }


    function initializeWorlds(root, signal, desktopViewport, reducedMotion) {
      var mobile = root.querySelector(".frkm-scene__mobile");
      if (!mobile) return;
      var track = mobile.querySelector(".frkm-scene__worlds");
      var slides = Array.prototype.slice.call(mobile.querySelectorAll(".frkm-scene__world"));
      var images = Array.prototype.slice.call(mobile.querySelectorAll("[data-mobile-src]"));
      var selectors = Array.prototype.slice.call(mobile.querySelectorAll("[data-world-index]"));
      var choices = mobile.querySelector(".frkm-scene__world-choices");
      var toggle = mobile.querySelector("[data-world-toggle]");
      var status = mobile.querySelector("[data-world-status]");
      var index = 0;
      var direction = 1;
      var started = false;
      var loaded = false;
      var resizeFrame = 0;
      var scrollFrame = 0;
      var autoplayTimer = 0;
      var inView = !("IntersectionObserver" in window);
      var userPaused = false;
      var focusPaused = false;
      var interacting = false;
      var gestureMoved = false;
      var gestureX = 0;
      var gestureY = 0;
      var toggleWasPlaying = null;
      if (!track || (slides.length !== 3 && slides.length !== 4) || images.length !== slides.length || selectors.length !== slides.length) return;

      function mobileGeometryIsValid(image, natural) {
        var sourceWidth = Number(image.getAttribute("width"));
        var sourceHeight = Number(image.getAttribute("height"));
        var width = natural ? image.naturalWidth : sourceWidth;
        var height = natural ? image.naturalHeight : sourceHeight;
        var expected = image.getAttribute("data-mobile-layout") === "portrait" ? sourceWidth / sourceHeight : 1672 / 941;
        return sourceWidth > 0 && sourceHeight > 0 && width > 0 && height > 0 && Math.abs(width / height - expected) < 0.002;
      }

      function canAutoplay() {
        return !signal.aborted && loaded && !desktopViewport.matches &&
          !reducedMotion.matches && !document.hidden && inView &&
          !userPaused && !focusPaused && !interacting;
      }

      function clearAutoplay() {
        window.clearTimeout(autoplayTimer);
        autoplayTimer = 0;
      }

      function updatePlayback() {
        var playing = canAutoplay();
        root.setAttribute("data-world-autoplay", playing ? "playing" : "paused");
        if (toggle) {
          toggle.hidden = !loaded || desktopViewport.matches || reducedMotion.matches;
          toggle.setAttribute("data-paused", String(!playing));
          toggle.setAttribute("aria-label", toggle.getAttribute(playing ? "data-pause-label" : "data-play-label"));
        }
        if (status) status.setAttribute("aria-live", playing ? "off" : "polite");
      }

      function scheduleAutoplay(delay) {
        clearAutoplay();
        updatePlayback();
        if (!canAutoplay()) return;
        autoplayTimer = window.setTimeout(function () {
          autoplayTimer = 0;
          if (!canAutoplay()) return;
          go(index + direction, true);
          scheduleAutoplay(4500);
        }, delay || 4500);
      }

      if ("IntersectionObserver" in window) {
        var sceneVisibility = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          root.toggleAttribute("data-mobile-in-view", entry.isIntersecting);
          inView = entry.isIntersecting && entry.intersectionRatio >= 0.6;
          scheduleAutoplay();
        }, { threshold: [0, 0.6] });
        sceneVisibility.observe(root);
        signal.addEventListener("abort", function () {
          sceneVisibility.disconnect();
          root.removeAttribute("data-mobile-in-view");
        }, { once: true });
      }

      function paint(value) {
        var previous = index;
        index = Math.max(0, Math.min(slides.length - 1, value));
        if (index === 0) direction = 1;
        if (index === slides.length - 1) direction = -1;
        root.setAttribute("data-world", String(index));
        selectors.forEach(function (button, i) {
          button.setAttribute("aria-current", i === index ? "true" : "false");
        });
        if (status && (previous !== index || !status.textContent)) {
          status.textContent = slides[index].getAttribute("aria-label");
        }
      }

      function syncProgress() {
        if (!track.clientWidth) return;
        var progress = Math.max(0, Math.min(slides.length - 1, track.scrollLeft / track.clientWidth));
        if (choices) choices.style.setProperty("--world-progress", String(progress));
        paint(Math.round(progress));
      }

      function go(value, smooth) {
        paint(value);
        track.scrollTo({
          left: index * track.clientWidth,
          behavior: smooth && !reducedMotion.matches ? "smooth" : "auto"
        });
        syncProgress();
      }

      function beginInteraction(event) {
        var point = event.touches ? event.touches[0] : event;
        if (!point) return;
        gestureX = point.clientX;
        gestureY = point.clientY;
        gestureMoved = false;
        interacting = true;
        clearAutoplay();
        updatePlayback();
      }

      function moveInteraction(event) {
        if (!interacting) return;
        var point = event.touches ? event.touches[0] : event;
        if (point && Math.max(Math.abs(point.clientX - gestureX), Math.abs(point.clientY - gestureY)) > 10) {
          gestureMoved = true;
        }
      }

      function endInteraction() {
        interacting = false;
        scheduleAutoplay(8000);
      }

      function sync() {
        var eligible = !signal.aborted && !desktopViewport.matches;
        root.classList.toggle("frkm-scene--mobile-ready", eligible && loaded);
        if (eligible && loaded) go(index, false);
        scheduleAutoplay();
        if (!eligible || started) return;
        if (!images.every(function (image) {
          return mobileGeometryIsValid(image, false);
        })) return;
        started = true;
        mobile.querySelectorAll("[data-world-room-src]").forEach(function (room) {
          room.src = room.getAttribute("data-world-room-src");
        });
        mobile.querySelectorAll("[data-world-light-src]").forEach(function (light) {
          light.addEventListener("error", function () { light.hidden = true; }, { once: true, signal: signal });
          light.src = light.getAttribute("data-world-light-src");
        });
        Promise.all(images.map(function (image) {
          return new Promise(function (resolve, reject) {
            image.addEventListener("load", function () {
              if (!mobileGeometryIsValid(image, true)) {
                reject(new Error("Unexpected mobile canvas"));
              } else resolve();
            }, { once: true, signal: signal });
            image.addEventListener("error", reject, { once: true, signal: signal });
            signal.addEventListener("abort", function () { reject(new Error("Section unloaded")); }, { once: true });
            image.src = image.getAttribute("data-mobile-src");
          });
        })).then(function () { loaded = true; sync(); }).catch(function () {
          loaded = false;
          root.classList.remove("frkm-scene--mobile-ready");
          scheduleAutoplay();
        });
      }

      selectors.forEach(function (button, i) {
        button.addEventListener("click", function () {
          go(i, true);
          scheduleAutoplay(8000);
        }, { signal: signal });
      });
      if (toggle) {
        toggle.addEventListener("pointerdown", function () {
          toggleWasPlaying = canAutoplay();
        }, { passive: true, signal: signal });
        toggle.addEventListener("click", function () {
          userPaused = toggleWasPlaying === null ? canAutoplay() : toggleWasPlaying;
          toggleWasPlaying = null;
          focusPaused = false;
          scheduleAutoplay();
        }, { signal: signal });
      }
      track.addEventListener("scroll", function () {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(function () {
          scrollFrame = 0;
          syncProgress();
        });
      }, { passive: true, signal: signal });
      track.addEventListener("pointerdown", beginInteraction, { passive: true, signal: signal });
      track.addEventListener("pointermove", moveInteraction, { passive: true, signal: signal });
      window.addEventListener("pointerup", function () {
        if (interacting) endInteraction();
      }, { passive: true, signal: signal });
      track.addEventListener("pointercancel", function (event) {
        gestureMoved = true;
        if (event.pointerType !== "touch") endInteraction();
      }, { passive: true, signal: signal });
      track.addEventListener("touchstart", beginInteraction, { passive: true, signal: signal });
      track.addEventListener("touchmove", moveInteraction, { passive: true, signal: signal });
      window.addEventListener("touchend", function () {
        if (interacting) endInteraction();
      }, { passive: true, signal: signal });
      window.addEventListener("touchcancel", function () {
        if (interacting) endInteraction();
      }, { passive: true, signal: signal });
      track.addEventListener("click", function (event) {
        if (gestureMoved && event.detail !== 0 && event.target.closest("a")) {
          event.preventDefault();
          event.stopPropagation();
        }
      }, { capture: true, signal: signal });
      track.addEventListener("wheel", function () { scheduleAutoplay(8000); }, { passive: true, signal: signal });
      mobile.addEventListener("focusin", function () {
        focusPaused = true;
        clearAutoplay();
        updatePlayback();
      }, { signal: signal });
      mobile.addEventListener("focusout", function (event) {
        focusPaused = mobile.contains(event.relatedTarget);
        scheduleAutoplay(8000);
      }, { signal: signal });
      track.addEventListener("keydown", function (event) {
        if (event.key === "ArrowRight") { event.preventDefault(); go(index + 1, true); }
        if (event.key === "ArrowLeft") { event.preventDefault(); go(index - 1, true); }
        if (event.key === "Home") { event.preventDefault(); go(0, true); }
        if (event.key === "End") { event.preventDefault(); go(slides.length - 1, true); }
      }, { signal: signal });
      window.addEventListener("resize", function () {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(function () {
          if (loaded && !desktopViewport.matches) go(index, false);
          scheduleAutoplay();
        });
      }, { signal: signal });
      desktopViewport.addEventListener("change", sync, { signal: signal });
      reducedMotion.addEventListener("change", function () {
        if (loaded && !desktopViewport.matches) go(index, false);
        scheduleAutoplay();
      }, { signal: signal });
      document.addEventListener("visibilitychange", function () { scheduleAutoplay(); }, { signal: signal });
      signal.addEventListener("abort", function () {
        clearAutoplay();
        window.cancelAnimationFrame(resizeFrame);
        window.cancelAnimationFrame(scrollFrame);
        root.removeAttribute("data-world-autoplay");
        root.classList.remove("frkm-scene--mobile-ready");
      }, { once: true });
      paint(0);
      sync();
    }

    function initialize(root) {
      if (controllers.has(root)) return;

      var controller = new AbortController();
      var signal = controller.signal;
      var finePointer = window.matchMedia("(hover: hover) and (pointer: fine)");
      var desktopViewport = window.matchMedia("(min-width: 769px)");
      var reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      var hitTargets = Array.prototype.slice.call(root.querySelectorAll(".frkm-scene__hitmap [data-scene-target]"));
      var collectionLinks = Array.prototype.slice.call(root.querySelectorAll("a.frkm-scene__collection[data-scene-target]"));
      var master = root.querySelector(".frkm-scene__master");
      var layerImages = Array.prototype.slice.call(root.querySelectorAll(".frkm-scene__objects img[data-src]"));
      var maskedObjects = Array.prototype.slice.call(root.querySelectorAll(".frkm-scene__object[data-mask-src]"));
      var layersStarted = false;
      var layersLoaded = false;
      var clearTimer = 0;

      controllers.set(root, controller);
      initializeWorlds(root, signal, desktopViewport, reducedMotion);
      signal.addEventListener("abort", function () {
        cancelClear();
        root.setAttribute("data-active", "");
        root.classList.remove("frkm-scene--layers-ready", "frkm-scene--interactive");
      }, { once: true });

      function cancelClear() {
        if (!clearTimer) return;
        window.clearTimeout(clearTimer);
        clearTimer = 0;
      }

      function clearActive() {
        cancelClear();
        root.setAttribute("data-active", "");
      }

      function geometryIsCanonical(image, natural) {
        if (!image) return false;
        var expected = image.classList.contains("frkm-scene__light-crop") ? 1599 / 984 : 1672 / 941;
        var width = natural ? image.naturalWidth : Number(image.getAttribute("width"));
        var height = natural ? image.naturalHeight : Number(image.getAttribute("height"));
        return width > 0 && height > 0 && Math.abs(width / height - expected) < 0.002;
      }

      function syncReadiness() {
        var eligible = !signal.aborted && desktopViewport.matches && !reducedMotion.matches;
        root.classList.toggle("frkm-scene--layers-ready", eligible && layersLoaded);
        if (!eligible) clearActive();
      }

      function ensureLayers() {
        syncReadiness();
        if (signal.aborted || layersStarted || reducedMotion.matches || !desktopViewport.matches) return;
        if (root.getAttribute("data-layers-configured") !== "true") return;
        if (!window.CSS) return;
        if (!CSS.supports("mask-image", "url(test.png)") && !CSS.supports("-webkit-mask-image", "url(test.png)")) return;
        if (!geometryIsCanonical(master, false) || !layerImages.every(function (image) { return geometryIsCanonical(image, false); })) return;
        if (!master.complete || !geometryIsCanonical(master, true)) return;

        layersStarted = true;

        maskedObjects.forEach(function (object) {
          object.style.setProperty("--frkm-subject-mask", "url(" + object.getAttribute("data-mask-src") + ")");
        });

        Promise.all(layerImages.map(function (image) {
          return new Promise(function (resolve, reject) {
            function loaded() {
              if (!geometryIsCanonical(image, true)) {
                reject(new Error("Unexpected layer geometry"));
                return;
              }
              resolve();
            }

            image.addEventListener("load", loaded, { once: true, signal: signal });
            image.addEventListener("error", reject, { once: true, signal: signal });
            signal.addEventListener("abort", function () { reject(new Error("Section unloaded")); }, { once: true });
            image.src = image.getAttribute("data-src");
          });
        })).then(function () {
          layersLoaded = true;
          syncReadiness();
        }).catch(function () {
          layersLoaded = false;
          syncReadiness();
        });
      }

      function setActive(target) {
        cancelClear();
        if (!desktopViewport.matches || reducedMotion.matches) target = "";
        root.setAttribute("data-active", target || "");
        if (target) ensureLayers();
      }

      function scheduleClear() {
        cancelClear();
        clearTimer = window.setTimeout(function () {
          root.setAttribute("data-active", "");
          clearTimer = 0;
        }, 120);
      }

      hitTargets.forEach(function (target) {
        var name = target.getAttribute("data-scene-target");
        target.addEventListener("click", function () { setActive(name); }, { signal: signal });
        target.addEventListener("pointerenter", function () {
          if (finePointer.matches) setActive(name);
        }, { signal: signal });
        target.addEventListener("pointerleave", function () {
          if (finePointer.matches) scheduleClear();
        }, { signal: signal });
        target.addEventListener("pointercancel", scheduleClear, { signal: signal });
        target.addEventListener("pointerup", function (event) {
          if (finePointer.matches && event.pointerType === "mouse") return;
          setActive(name);
        }, { signal: signal });
      });

      collectionLinks.forEach(function (link) {
        var name = link.getAttribute("data-scene-target");
        link.addEventListener("focusin", function () { setActive(name); }, { signal: signal });
        link.addEventListener("focusout", scheduleClear, { signal: signal });
        link.addEventListener("pointerenter", function () {
          if (finePointer.matches) setActive(name);
        }, { signal: signal });
        link.addEventListener("pointerleave", function () {
          if (finePointer.matches) scheduleClear();
        }, { signal: signal });
      });

      root.addEventListener("keydown", function (event) {
        if (event.key === "Escape") clearActive();
      }, { signal: signal });

      document.addEventListener("pointerdown", function (event) {
        if (finePointer.matches || root.contains(event.target)) return;
        clearActive();
      }, { signal: signal });

      reducedMotion.addEventListener("change", syncReadiness, { signal: signal });
      desktopViewport.addEventListener("change", syncReadiness, { signal: signal });
      if (master) {
        master.addEventListener("load", function () {
          if (root.getAttribute("data-active")) ensureLayers();
        }, { signal: signal });
      }

      root.classList.add("frkm-scene--interactive");
    }

    function destroy(root) {
      var controller = controllers.get(root);
      if (!controller) return;
      controller.abort();
      controllers.delete(root);
    }

    function scan(scope) {
      rootsWithin(scope).forEach(initialize);
    }

    window[runtimeKey] = { scan: scan, destroy: destroy };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", function () { scan(document); }, { once: true });
    } else {
      scan(document);
    }

    document.addEventListener("shopify:section:load", function (event) { scan(event.target); });
    document.addEventListener("shopify:section:unload", function (event) {
      rootsWithin(event.target).forEach(destroy);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
